export default __webpack_public_path__ + "static/media/farm.18a39971.jpg";